export default __webpack_public_path__ + "static/testimonials-e403367120509433b66e73c214202228.png";